import { Container } from 'inversify';
import { TYPES } from './DI/TYPES';
import { StorageService } from './services/Storage.service';

export const container = new Container();
container.bind<StorageService>(TYPES.storageService).to(StorageService);
